import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"

export default function ConfirmAlert({
  title,
  description,
  open,
  onOkClick,
  onCancelClick,
  onClose,
  okVisible = true,
  cancelVisible = true,
  okText = "Agree",
  cancelText = "Disagree",
  secondaryText = "",
  onSecondaryClick,
  secondaryButton = false,
  fontSettings = {},
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      PaperProps={{
        sx: [
          fontSettings?.fontFamily && {
            "& .MuiTypography-root, button, textarea, input, .ql-editor p": {
              fontFamily: fontSettings.fontFamily,
            },
          },
          fontSettings?.bgColor && {
            backgroundColor: fontSettings.bgColor,
          },
        ],
      }}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {okVisible && <Button onClick={onOkClick}>{okText}</Button>}
        {cancelVisible && (
          <Button onClick={onCancelClick} autoFocus>
            {cancelText}
          </Button>
        )}
        {secondaryButton && (
          <Button onClick={onSecondaryClick}>{secondaryText}</Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
